import NumberInputDisplay from '../src/NumberInputDisplay';
export default NumberInputDisplay;
